module.exports = __webpack_public_path__ + "media/images/active_material/icons/clear-2565ae2e4b636978ad38a64fade9a011.svg";